<div class="row mt-5 gap-2" id="top-wrapper">
    <div class="pt-2 pb-4">
        <button class="btn btn-primary px-4" (click)="goBack()">
            <i class="fa fa-chevron-left mr-3"></i>&nbsp;{{
            "labels.back" | translate
            }}
        </button>
    </div>
    <h3 class="ml-3">{{taskTitle}}</h3>
    <div class="details">
        <div class="row col-12">
            @if(contractsByProfileAndCustomer.length > 0) {

            <div class="detail-section col-6">
                <h4 class="title">{{
                    "contractsDetails.overviewOfContractsWithCustomer"
                    | translate : { consultant: consultantName, customer: customerName}
                    }}</h4>
                <div class="contract-profile">
                    <ag-grid-angular style="width: 100%; height: 100%" [rowData]="contractsByProfileAndCustomer"
                        [columnDefs]="colDefs" [defaultColDef]="defaultColDef" [stopEditingWhenCellsLoseFocus]="true"
                        (rowDoubleClicked)="onRowClicked($event)" />
                </div>
            </div>
            }
            @if(contractByProfile.length > 0) {
            <div class="detail-section col-6">
                <h4 class="title">{{
                    "contractsDetails.overviewOfContracts"
                    | translate : { consultant: consultantName}
                    }}</h4>
                <div class="contract-profile">
                    <ag-grid-angular style="width: 100%; height: 100%" [rowData]="contractByProfile"
                        [columnDefs]="colDefsByProgileId" [defaultColDef]="defaultColDef" [stopEditingWhenCellsLoseFocus]="true"
                        (rowDoubleClicked)="onRowClicked($event)" />
                </div>
            </div>
            }
        </div>
        <div></div>
    </div>
    <div class="tab-container">
        <button [ngClass]="{'active':showTab == 'Sow' }" class="btn btn-outline-primary tab-button"
            (click)="goToTab('Sow')">
            {{ "sow.title" | translate }}
        </button>
        <button [ngClass]="{'active':showTab == 'Comments' }" class="btn btn-outline-primary tab-button"
            (click)="goToTab('Comments')">
            {{ "contractComment.title" | translate }}
        </button>

    </div>

    @if(showTab === "Sow") {
    <app-sow [contractId]="contractId"></app-sow>
    }@else if(showTab ==="Comments") {
    <app-contract-comments [contractId]="contractId"></app-contract-comments>
    }

</div>